// 网速
let speedInterval = null
// 
let networkInternet = null
//
let reNetWorkInternet = null
//网络连接状态
// let getConnectStatus = null
let time = 10000
let that = null
export function TestInternet (data) {
    that = data
	startNetwork()
    startSpeed()
}
export function stopTest () {
	endNetwork()
	endSpeed()
}
 
 
function getConnectStatus() {
	return window.navigator.onLine? 1 : 0
}
 
function disconnet() {
	window.clearInterval(reNetWorkInternet)
    that.$store.dispatch('setNetwork',0)
	reNetWorkInternet = null
	window.setTimeout(() => {
		// 设置定时器
		reNetWorkInternet = window.setInterval(() => {
			if (getConnectStatus() == 1) {
			} else {
				disconnet()
			}
		}, time)
	}, 2 * time)
}
 
const speed = {
	/**
	 * 网速过慢
	 */
	bad : function(){
     that.$store.dispatch('setNetwork',1)
	 window.setTimeout(function(){
		if(getConnectStatus() === 1) {
		 window.clearInterval(networkInternet)
		 networkInternet = null
		 startSpeed()
		} else {
		 disconnect()
		}
	 }, 2 * time)
	},
	/**
	 * 网速中等
	 */
	medium : function(){
    //  this.$store.commit('setNetwork',1)
    that.$store.dispatch('setNetwork',2)
	},
	/**
	 * 网速极佳
	 */
	great : function(){
    that.$store.dispatch('setNetwork',3)
	}
}
 
// 开始测速
function startSpeed () {
	// 调用清楚定时器
	window.clearInterval(speedInterval)
	speedInterval = null;
	if (getConnectStatus() === 1) {
		speedInterval = window.setInterval( () => {
			let start = new Date().getTime()
			if (getConnectStatus() === 1) {
				let img = document.getElementById('networkSpeedImg')
				// 使用一个不展示的图片加载进行网速检测
				if (!!!img) {
					img = document.createElement('IMG')
					img.id = 'networkSpeedImg'
					img.style.display = 'none'
					document.body.appendChild(img)
				}
				try {
					img.src = 'https://www.guanmini.com/manage/test/vue/img/icon-02.72843f09.png?t=' + new Date().getTime()
					img.onload = function() {
						console.log('执行中')
						let end = new Date().getTime()
						let delta = (14.9*1024) / (end - start) 
						console.log(start,end)
						console.log(delta)
						if (delta < 100) {
							speed.bad()
						} else if (delta < 200) {
							speed.medium()
						} else {
							speed.great()
						}
					}
				} catch ( e ) {
					speed.bad()
				}
			} else {
				disconnet()
			}
		}, time)
	} else {
		disconnet()
	}
}
 
// 停止测速
function endSpeed () {
	window.clearInterval(speedInterval);
  speedInterval = null;
}
 
// 开启网络连接监测
function startNetwork () {
	if (getConnectStatus() === 1) {
		networkInternet = window.setInterval(() => {
			if (getConnectStatus() === 0) {
				disconnet()
			}
		}, time)
	} else {
		disconnet()
	}
}
 
// 结束网络连接监测
function endNetwork () {
	window.clearInterval(networkInternet)
	networkInternet = null
}
